/**
 * Total project value follows the project's invoices — the same rule the
 * server applies in `server/src/services/projectValue.ts`:
 *
 *  - invoice money removed (a deleted invoice, a lowered amount) lowers the
 *    value by exactly that much;
 *  - invoice money added raises the value once the invoices add up to more
 *    than it. While part of the value isn't invoiced yet (e.g. one 50%
 *    payment recorded against a €5,250 project), new invoices fill that gap
 *    first instead of inflating the total.
 *
 * Used to preview the new total while editing an invoice.
 */
export function projectValueAfter(
  value: number,
  invoicedTotal: number,
  change: { from?: number; to?: number },
): number {
  const from = change.from ?? 0;
  const to = change.to ?? 0;
  const removed = Math.max(0, from - to);
  const invoiced = invoicedTotal - from + to;
  return Math.max(0, value - removed, invoiced);
}

/** An invoice's share of the total project value. */
export function shareOfProjectValue(amount: number, projectValue: number): number {
  return projectValue > 0 ? Math.round((amount / projectValue) * 100) : 0;
}
